// extracted by mini-css-extract-plugin
export var benefits = "index-module--benefits--3c842";
export var content = "index-module--content--2931b";
export var desc = "index-module--desc--e991f";
export var golbal = "index-module--golbal--7f456";
export var item = "index-module--item--c268a";
export var label = "index-module--label--e73e8";
export var title = "index-module--title--eb2c7";